import { render, staticRenderFns } from "./eanNotifyUser.vue?vue&type=template&id=2b0fbd16"
import script from "./eanNotifyUser.vue?vue&type=script&lang=js"
export * from "./eanNotifyUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports